export default __webpack_public_path__ + "static/assets/med_pill_round_out_L0_solid_l_01_f.9d0c5c05.png";